import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/simp_in/step2';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { TypeOuiNonNbCandidatReduitFNSSimple } from '../models/TypeOuiNonNbCandidatReduitFNSSimple';
import { Oui_TypeOuiNonNbCandidatReduitFNSSimple } from '../models/Oui_TypeOuiNonNbCandidatReduitFNSSimple';
@Component({
	selector: 'app-type-oui-non-nb-candidat-reduitFNS-simple',
	templateUrl: './type-oui-non-nb-candidat-reduitFNS-simple.component.html'
})
export class TypeOuiNonNbCandidatReduitFNSSimpleComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeOuiNonNbCandidatReduitFNSSimple';
	@Input() parentForm: FormGroup;

	@Input() disabled: boolean;
	@Input() nbCandidatReduit: TypeOuiNonNbCandidatReduitFNSSimple;

	public step2 = new Step2();

	constructor() {}

	public ngOnInit() {
		if ((this.nbCandidatReduit.non === RadioCheckBoxEnum.emptyValue || this.nbCandidatReduit.non === 'Non') && this.nbCandidatReduit.oui == null) {
			this.nbCandidatReduit.non = RadioCheckBoxEnum.nonValue;
		}
		else if (this.nbCandidatReduit.oui) {
			this.nbCandidatReduit.non = RadioCheckBoxEnum.ouiValue;
		}
		else {
			this.nbCandidatReduit.non = RadioCheckBoxEnum.emptyValue;
		}
	}

	isNbCandidatReduitOui() {
		if (this.parentForm.controls[this.getUid() + '_SepAtt_non'].value === 'Oui') {
					if (!this.nbCandidatReduit.oui) {
						this.nbCandidatReduit.oui = new Oui_TypeOuiNonNbCandidatReduitFNSSimple();
					}
					return true;
				}
			
				this.nbCandidatReduit.oui = null;
				return false;
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
